import React from 'react';
import MarkGuard from './MarkGuard';
import MarkRoutes from './MarkRoutes';
import UnsavedChangesProvider from './components/UnsavedChangesProvider';
import MarkLayout from './MarkLayout';

const MarkPage: React.FC = () => {
    return (
        <MarkGuard>
            <MarkLayout>
                <UnsavedChangesProvider>
                    <MarkRoutes />
                </UnsavedChangesProvider>
            </MarkLayout>
        </MarkGuard>
    );
};

export default MarkPage;
